import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { globalBaseTheme } from "@/themes/base.ts";
import { styled } from "@linaria/react";
import { t } from "@/themes/theme.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { SignalRWrapper } from "@/wrappers/SignalRWrapper.tsx";
import { API_FLOW, API_MAIN, PRECONNECT_URLS, PRODUCTION } from "@/constants/settings.ts";
import { addNewPreconnect } from "@/helpers/preconnect.ts";
import { useEffect } from "react";
import { TutorWrapper } from "@/wrappers/TutorWrapper.tsx";
import { SettingsWrapper } from "@/wrappers/SettingsWrapper.tsx";

const router = createRouter({
  routeTree,
  defaultViewTransition: {
    types: ({ fromLocation }) => {
      if (
        fromLocation &&
        (fromLocation.pathname.includes("/auth/") ||
          fromLocation.pathname.includes("/flow-session/"))
      ) {
        return false;
      }
      return ["fade-in"];
    },
  },
  scrollRestoration: true,
  defaultPreload: "intent",
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  max-height: 100dvh;
  height: 100dvh;
  background: ${t.brandPrimary};
`;

const PRECONNECT_LIST = [API_MAIN, API_FLOW];

const queryClient = new QueryClient();
if (!PRODUCTION) window.__TANSTACK_QUERY_CLIENT__ = queryClient;
window.QueryClient = queryClient;

export const App = () => {
  // Small optimization: preconnect to some url's ahead of time to avoid DNS overhead
  useEffect(() => {
    PRECONNECT_LIST.forEach((url) => {
      addNewPreconnect(url);
    });

    PRECONNECT_URLS.forEach((url) => {
      addNewPreconnect(url);
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SettingsWrapper>
        <TutorWrapper>
          <SignalRWrapper>
            <PageWrapper className={globalBaseTheme}>
              <Toaster
                position={"top-center"}
                richColors
                theme={"light"}
                toastOptions={{
                  closeButton: true,
                  style: {
                    border: t.brandBorderSegment,
                    borderRadius: t.brandBorderRadius,
                  },
                }}
              />
              <Toaster
                id={"chat"}
                position={"bottom-center"}
                richColors
                theme={"light"}
                toastOptions={{
                  closeButton: true,
                  style: {
                    border: t.brandBorderSegment,
                    borderRadius: t.brandBorderRadius,
                  },
                }}
              />
              <RouterProvider router={router} />
            </PageWrapper>
          </SignalRWrapper>
        </TutorWrapper>
      </SettingsWrapper>
    </QueryClientProvider>
  );
};
